export const storage = {
  title: 'Objektspeicher',
  subtitle: 'S3-kompatibler Objektspeicher',

  buckets: {
    title: 'Buckets',
    empty: 'Noch keine Buckets',
    emptyHint: 'Erstelle deinen ersten Bucket, um Objekte zu speichern.',
    columns: {
      name: 'Name',
      region: 'Region',
      storage: 'Speicher',
      objects: 'Objekte',
      cost: 'Kosten/Mo.',
      created: 'Erstellt',
      actions: 'Aktionen'
    },
    endpoint: 'Endpunkt',
    endpointValue: 'https://storage.itsh.dev',
    create: {
      title: 'Bucket erstellen',
      subtitle: 'Einen neuen S3-kompatiblen Speicher-Bucket anlegen',
      name: 'Bucket-Name',
      namePlaceholder: 'mein-bucket',
      nameHint: '3-63 Zeichen, Kleinbuchstaben, Zahlen und Bindestriche',
      region: 'Region',
      button: 'Bucket erstellen',
      invalidName: 'Ungültiger Bucket-Name',
      checking: 'Name wird geprüft ...',
      available: 'Name ist verfügbar',
      takenHint:
        'Bucket-Namen gelten für alle Kunden gemeinsam, dieser Name muss also weltweit eindeutig sein. Stell deinem Namen am besten dein Projekt oder deine Firma voran.'
    },
    delete: {
      title: 'Bucket löschen',
      message: 'Bist du sicher, dass du diesen Bucket löschen möchtest? Alle gespeicherten Objekte werden unwiderruflich entfernt.',
      warning:
        'Diese Aktion kann nicht rückgängig gemacht werden. Der Name wird sofort wieder freigegeben und kann von jedem anderen Kunden übernommen werden.',
      force: 'Erzwingen (alle Objekte entfernen)',
      button: 'Bucket löschen',
      failed: 'Bucket konnte nicht gelöscht werden.',
      deactivatedCredentials:
        'Diese Zugangsdaten waren nur für diesen Bucket freigegeben und wurden deaktiviert:'
    },
    public: {
      label: 'Öffentlicher Zugriff',
      enable: 'Öffentlich machen',
      disable: 'Privat machen',
      enabled: 'Öffentlich',
      disabled: 'Privat',
      url: 'Öffentliche URL',
      hint: 'Jeder kann Objekte per GET abrufen. Uploads erfordern weiterhin Zugangsdaten.',
      hintPrivate: 'Nur Anfragen mit gültigen Zugangsdaten können Objekte abrufen oder hochladen.',
      warning: 'Alle aktuellen und zukünftigen Objekte in diesem Bucket werden öffentlich zugänglich sein.',
      confirmEnable: 'Bist du sicher, dass du den öffentlichen Zugriff aktivieren möchtest? Alle Objekte in diesem Bucket — bestehende und zukünftige — werden für jeden über das Internet abrufbar sein.',
      confirm: 'Öffentlich machen'
    },
    regions: {
      'eu-central-1': 'EU Zentral (Nürnberg)',
      'eu-central-2': 'EU Zentral (Falkenstein)',
      'eu-north-1': 'EU Nord (Helsinki)'
    }
  },

  credentials: {
    title: 'Zugriffsschlüssel',
    empty: 'Noch keine Zugriffsschlüssel',
    emptyHint: 'Erstelle einen Zugriffsschlüssel, um dich über S3-kompatible Tools zu verbinden.',
    columns: {
      name: 'Name',
      accessKey: 'Zugriffsschlüssel',
      status: 'Status',
      created: 'Erstellt',
      lastUsed: 'Zuletzt verwendet',
      actions: 'Aktionen'
    },
    active: 'Aktiv',
    inactive: 'Inaktiv',
    never: 'Nie',
    create: {
      title: 'Zugriffsschlüssel erstellen',
      subtitle: 'Ein neues S3-kompatibles Schlüsselpaar generieren',
      name: 'Schlüsselname',
      namePlaceholder: 'mein-app-key',
      button: 'Schlüssel erstellen'
    },
    rotate: {
      title: 'Secret rotieren',
      message: 'Dies generiert einen neuen geheimen Schlüssel. Der alte Schlüssel wird sofort ungültig.',
      button: 'Secret rotieren'
    },
    delete: {
      title: 'Zugriffsschlüssel löschen',
      message: 'Bist du sicher, dass du diesen Zugriffsschlüssel löschen möchtest? Anwendungen, die diesen Schlüssel verwenden, verlieren sofort den Zugriff.',
      button: 'Schlüssel löschen'
    },
    secret: {
      title: 'Zugriffsschlüssel erstellt',
      warning: 'Speichere diese Zugangsdaten jetzt. Der geheime Schlüssel wird nicht erneut angezeigt.',
      accessKey: 'Zugriffsschlüssel-ID',
      secretKey: 'Geheimer Zugriffsschlüssel',
      endpoint: 'S3-Endpunkt',
      copied: 'Kopiert!',
      tabs: {
        awsCli: 'AWS CLI',
        rclone: 'rclone',
        s3cmd: 's3cmd'
      }
    },
    scope: {
      label: 'Bucket-Zugriff',
      all: 'Alle Buckets',
      restricted: 'Eingeschr.',
      help: 'Leer lassen für Zugriff auf alle Buckets',
      edit: 'Zugriff bearbeiten'
    },
    levels: {
      selectLabel: 'Zugriffsstufe für {bucket}',
      defaultLabel: 'Stufe für alle Buckets',
      defaultHelp:
        'Gilt für jeden Bucket in deinem Konto, solange du keine einzelnen Buckets auswählst.',
      defaultIgnored:
        'Wird nicht verwendet, solange einzelne Buckets ausgewählt sind: dann gilt die Stufe pro Bucket.',
      publicWarning:
        'Öffentliche Buckets ({buckets}) kann jeder ohne Schlüssel lesen. Nur-Schreiben und Nur-Lesen ändern daran nichts.',
      ro: {
        label: 'Nur Lesen',
        short: 'Lesen'
      },
      wo: {
        label: 'Nur Schreiben (kein Lesen, kein Löschen)',
        short: 'Schreiben'
      },
      rw: {
        label: 'Lesen und Schreiben (inkl. Löschen)',
        short: 'Lesen/Schreiben'
      },
      full: {
        label: 'Voll (inkl. Bucket-Einstellungen)',
        short: 'Voll'
      }
    }
  },

  notifications: {
    bucketCreated: 'Bucket erstellt',
    bucketDeleted: 'Bucket gelöscht',
    credentialCreated: 'Zugriffsschlüssel erstellt',
    credentialDeleted: 'Zugriffsschlüssel gelöscht',
    credentialRotated: 'Geheimer Schlüssel rotiert',
    scopeUpdated: 'Bucket-Zugriff aktualisiert',
    bucketPublic: 'Bucket ist jetzt öffentlich',
    bucketPrivate: 'Bucket ist jetzt privat'
  }
} as const
